import React from "react";
import FilterNavbar from "components/Header/Navbar";
import MainSideBar from "./Components/Address/Address";
function SavedAddress() {
  return (
    <>
      <FilterNavbar />
      <MainSideBar />
    </>
  );
}

export default SavedAddress;
